import React from "react";
import icon from "../../assets/icon.png";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";

const styles = {
  footerContainer: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "60px 80px 20px 80px",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
  },
  footerContent: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "40px",
    borderBottom: "1px solid #333",
    paddingBottom: "40px",
    marginBottom: "20px",
  },
  footerSection: {
    flex: "1",
    minWidth: "200px",
  },
  logoSection: {
    flex: "1.5",
    minWidth: "250px",
  },
  logo: {
    width: "120px",
    marginBottom: "20px",
  },
  description: {
    lineHeight: "1.6",
    color: "#ccc",
  },
  socialIcons: {
    display: "flex",
    gap: "20px",
    marginTop: "20px",
  },
  socialIcon: {
    width: "24px",
    height: "24px",
    fill: "#FF7622",
    cursor: "pointer",
    transition: "transform 0.3s ease",
  },
  sectionTitle: {
    color: "#FF7622",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "25px",
    textTransform: "uppercase",
  },
  navList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navItem: {
    marginBottom: "15px",
  },
  navLink: {
    color: "#ccc",
    textDecoration: "none",
    transition: "color 0.3s ease",
  },
  navLinkHover: {
    color: "#ff9933",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    color: "#ccc",
  },
  contactIcon: {
    width: "20px",
    height: "20px",
    fill: "#FF7622",
    marginRight: "15px",
  },
  copyright: {
    textAlign: "left",
    color: "#555",
    fontSize: "12px",
    marginTop: "20px",
  },
};

const Footer = () => {
  return (
    <footer id="contact" style={styles.footerContainer}>
      <div style={styles.footerContent}>
        {/* Logo & About */}
        <div style={styles.logoSection}>
          <img src={icon} alt="Tiffo Foods Logo" style={styles.logo} />
          <p style={styles.description}>
            Our job is to fill your tummy with delicious food along with fast and free delivery.
          </p>
          <div style={styles.socialIcons}>
            <a
              href="https://www.instagram.com/tiffo_foods?igsh=OGt6OGdqYXk2ejBn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram
                style={styles.socialIcon}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </a>
            <a
              href="https://www.facebook.com/share/1BQsV1qMy2/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF
                style={styles.socialIcon}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </a>
            <a
              href="https://wa.me/message/ISMOUHKGTGZSO1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp
                style={styles.socialIcon}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div style={styles.footerSection}>
          <h3 style={styles.sectionTitle}>Tiffo Foods</h3>
          <ul style={styles.navList}>
            <li style={styles.navItem}>
              <a href="/menu" style={styles.navLink}>Our Menu</a>
            </li>
            <li style={styles.navItem}>
              <a href="/comingsoon" style={styles.navLink}>Download the App</a>
            </li>
            <li style={styles.navItem}>
              <a href="/comingsoon" style={styles.navLink}>Student Discounts</a>
            </li>
            <li style={styles.navItem}>
              <a href="/comingsoon" style={styles.navLink}>Join the VIP Club</a>
            </li>
            <li style={styles.navItem}>
              <a href="/contact" style={styles.navLink}>Feedback</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div style={styles.footerSection}>
          <h3 style={styles.sectionTitle}>Get In Touch</h3>
          <ul style={styles.navList}>
            <li style={styles.contactItem}>
              <FaMapMarkerAlt style={styles.contactIcon} /> Hyderabad
            </li>
            <li style={styles.contactItem}>
              <FaPhoneAlt style={styles.contactIcon} /> +91 756-954-8045
            </li>
            <li style={styles.contactItem}>
              <FaEnvelope style={styles.contactIcon} /> tiffofoods@gmail.com
            </li>
            <li style={styles.contactItem}>
              <FaClock style={styles.contactIcon} /> Mon-Sat: 9:00 AM - 7:00 PM
            </li>
          </ul>
        </div>

        {/* Corporate */}
        <div style={styles.footerSection}>
          <h3 style={styles.sectionTitle}>Corporate</h3>
          <ul style={styles.navList}>
            <li style={styles.navItem}>
              <a href="/aboutus" style={styles.navLink}>About Us</a>
            </li>
            <li style={styles.navItem}>
              <a href="/privacy" style={styles.navLink}>Privacy Policy</a>
            </li>
            <li style={styles.navItem}>
              <a href="/terms" style={styles.navLink}>Terms & Conditions</a>
            </li>
          </ul>
        </div>
      </div>

      <div style={styles.copyright}>
        © 2025 It's TiffoFoods. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
